import { create } from 'zustand';

interface NavigationState {
  isMenuHidden: boolean;
  keyboardJustClosed: boolean;
  isComposerCollapsed: boolean;
  isImageComposerCollapsed: boolean;
  isVideoComposerCollapsed: boolean;
  setMenuHidden: (hidden: boolean) => void;
  setKeyboardJustClosed: (closed: boolean) => void;
  setComposerCollapsed: (collapsed: boolean) => void;
  setImageComposerCollapsed: (collapsed: boolean) => void;
  setVideoComposerCollapsed: (collapsed: boolean) => void;
  toggleMenu: () => void;
}

const useNavigationStore = create<NavigationState>((set) => ({
  isMenuHidden: false,
  keyboardJustClosed: false,
  isComposerCollapsed: false,
  isImageComposerCollapsed: false,
  isVideoComposerCollapsed: false,
  setMenuHidden: (hidden) => set({ isMenuHidden: hidden }),
  setKeyboardJustClosed: (closed) => set({ keyboardJustClosed: closed }),
  setComposerCollapsed: (collapsed) => set({ isComposerCollapsed: collapsed }),
  setImageComposerCollapsed: (collapsed) => set({ isImageComposerCollapsed: collapsed }),
  setVideoComposerCollapsed: (collapsed) => set({ isVideoComposerCollapsed: collapsed }),
  toggleMenu: () => set((state) => ({ isMenuHidden: !state.isMenuHidden })),
}));

export { useNavigationStore };
